export default function slugify(text: string) {
  let slugifiedText = text.normalize('NFKC');
  slugifiedText = slugifiedText.toLowerCase();
  slugifiedText = slugifiedText.replaceAll(/[^\w\s-]/g, '');
  slugifiedText = slugifiedText.replaceAll(/[-\s]+/g, '-');
  slugifiedText = slugifiedText.replace(/[-_]+$/, '');
  slugifiedText = slugifiedText.replace(/^[-_]+/, '');
  return slugifiedText;
}
